<template>
	<div class="wrap">
        <div class="bnr">
            <img :src="detail.cover" alt="" />
            <p>{{detail.tips}}</p>
        </div>
        <div class="list">
            <div class="item" v-for="(item,index) in sence.list" :key="index">
                <img :src="item.bg_url" class="bg"/>
                <div class="tbg">
                    <div class="left">
                        <img class="icon" :src="item.logo_url"/>
                        <span>{{item.title}}</span>
                    </div>
                    <div class="right" :style="{background: item.price_color}">
                        <template v-if="item.price!=0">
                        ￥<span>{{item.price}}</span> <template v-if="item.is_top"> 起</template>
                        </template>
                        <template v-else><span style="font-size: 3.5vw;">免费</span></template>
                    </div>
                </div>
                <div class="bottom">
                    <span>{{item.tips}}</span>
                    <div class="btn">{{item.btn_str}}</div>
                </div>
                
                <div class="wx-open-weapp" v-if="item.status==0">
                    <div class="openh5" @click="stop"></div>
                </div>
                <div class="wx-open-weapp" v-else-if="item.is_check_h5==0 || (item.is_check_h5==1 && !isIOS)">
                    <wx-open-launch-weapp
                        class="launch-btn"
                        :username="item.ys_id"
                        :path="item.h5_url"
                    >
                        <script type="text/wxtag-template">
                            <style>.btn {width:100%;height:200px;color:#0000}</style>
                            <div class="btn">打开小程序</div>
                        </script>
                    </wx-open-launch-weapp>
                </div>
                <div class="wx-open-weapp" v-else>
                    <div class="openh5" @click="tohome"></div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import Modax from "modax";
	export default {
		computed: {
			...mapState(["detail"]),
        },
		data() {
			return {
				sence: {
                    list: [],
                    isIOS: false,
                }
			};
		},
		mounted() {
			this.getData();
            
            let UA = navigator.userAgent;
            this.isIOS = /iphone|ipod|ipad/gi.test(UA);
		},
		destroyed() {

		},
		methods: {
			getData(){
                this.$http.post("/wx/GetHomeInfo", {
					jid: localStorage.getItem("jid")
				}).then(res=>{
                    this.sence = res
                    document.title = res.jq_name
                })
            },
            stop(){
                Modax()
                    .width("80%")
                    .title("提示")
                    .content('暂未开放，敬请期待~')
                    .cancel(false)
                    .ok("我知道了")
                    .show();
            },
            tohome(){
                localStorage.removeItem("code_type")
                this.$router.go(-1);
            }
		},
	};
</script>

<style lang="scss" scoped>
.bnr{
    width: 100%;
    height: 370px;
    position: relative;
    img{
        display: block;
        height: 100%;
        width: 100%;
    }
    p{
        position: absolute;
        bottom: 0;
        left: 0;
        background: #0009;
        color: #fff;
        width: 100%;
        height: 10vw;
        line-height: 10vw;
        padding: 0 4%;
    }
}
.list{
    margin: 3vw;
    padding: 3vw;
    background: #fff;
    border-radius: 3px;
    .item{
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 3px 5px rgba(0,0,0,.1);
        position: relative;
        margin-bottom: 3vw;
        overflow: hidden;
        .bg{
            width: 100%;
            height: 26vw;
            display: block;
        }
        .tbg{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 26vw;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #fff;
            padding: 0 3vw;
        }
        .left{
            display: flex;
            align-items: center;
            font-size: 3.6vw;
        }
        .right{
            line-height: 6vw;
            border-radius: 3vw;
            color: #fff;
            background: #D9807C;
            padding: 0 2vw;
            font-size: 3vw;
            span{
                font-size: 4vw;
            }
        }
        .icon{
            width: 11.7vw;
            height: 11.7vw;
            margin-right: 3vw;
        }
        .bottom{
            padding: 0 3vw;
            height: 10vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 3.2vw;
        }
        .bottom .btn{
            color: #FF653A;
        }
    }
    .item:last-child{
        margin-bottom: 0;
    }
    .item:nth-child(2){
        .right{
            background: #8DA7C2;
        }
    }
    .item:nth-child(3){
        .right{
            background: #85A7A9;
        }
    }
}
.wx-open-weapp {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  overflow: hidden;
  .launch-btn {
    width: 100%;
    height: 100%;
    display: block;
  }
  .openh5{
    width: 100%;
    height: 100%;
  }
}
	.logo{
		display: block;
		margin: auto;
		width: 50vw;
		padding: 20vw 10vw 5vw;
	}
	h3{
		font-size: 5vw;
		text-align: center;
		margin-bottom: 5vw;
	}
	

</style>
